<template>
    <div :class="containerClass">
        <label :for="id" class="block font-bold">{{ label }}</label>
        <div v-if="subtitle" class="text-sm text-gray-700">
            {{ subtitle }}
        </div>

        <div class="mt-1">
            <select
                :id="id"
                :name="id"
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
                class="
                    mt-1
                    block
                    w-full
                    pl-3
                    pr-10
                    py-2
                    border-gray-300
                    focus:outline-none
                    focus:ring-indigo-500
                    focus:border-indigo-500
                    sm:text-sm
                "
                :class="{
                    'text-base': modelValue,
                }"
                :style="{
                    color: modelValue ? '' : '#6b7280',
                }"
            >
                <option
                    v-if="placeholderText"
                    :value="null"
                    disabled
                    selected
                    hidden
                >
                    {{ placeholderText }}
                </option>
                <option
                    v-for="select in selectOptions"
                    :key="select.key"
                    :value="select.key"
                >
                    {{ select.name }}
                </option>
            </select>
        </div>

        <div v-if="error" class="mt-1 text-sm text-red-400">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "modelValue",
        "id",
        "label",
        "subtitle",
        "placeholderText",
        "containerClass",
        "selectOptions",
        "error",
    ],
    emits: ["update:modelValue"],
};
</script>
